import authService from "@/services/authService";
import axios from "axios";
export default new class UserService {
    async resendInvitationEmail(id) {
        const token = await authService.currentUser.getIdToken();
        const instance = axios.create({
            baseURL: process.env.VUE_APP_FIREBASE_FUNCTIONS_URL,
            headers: { Authorization: `Bearer ${token}` }
        });
        try {
            await instance.post("users/resend-invitation-email", { id });
            return true;
        }
        catch (error) {
            console.error("resendInvitationEmail", error);
            return false;
        }
    }
};
